module.exports = __webpack_public_path__ + "static/email2-2d5fea5f5b4a79b78817d936affb3e4f.png";